// For Nested Menu
function makeNestedMenu() {
  const targetElement = "nav ul li";
  const hasChildClass = "menu-item-has-child";
  const hasChildDetectText = "[has-child]";
  const nestedMenuClass = "nested-menu";
  const nestedItemDetectText = "[child]";
  const nestedItemClass = "nested-menu-item";

  const menuItems = document.querySelectorAll(targetElement);

  const nestedMenuMap = new Map(); // Map to store nestedMenuItem to nestedMenu relationship

  let currentNestMenu = null;
  menuItems.forEach((menuItem, index) => {
    // Menu item that has child
    if (menuItem.textContent.indexOf(hasChildDetectText) >= 0) {
      menuItem.classList.add(hasChildClass);

      menuItem.innerHTML = menuItem.innerHTML.replace(hasChildDetectText, "");
      menuItem.innerHTML = menuItem.innerHTML.replace(/href="[^"]*"/, 'href="#"');

      const nestMenu = document.createElement('ul');
      nestMenu.classList.add(nestedMenuClass);
      currentNestMenu = nestMenu;
      menuItem.appendChild(nestMenu);

      menuItem.addEventListener('click', function (e) {
        e.stopPropagation();
        menuItem.classList.toggle("is-nested-open");
      });

      window.addEventListener('click', function (e) {
        if (menuItem.classList.contains('is-nested-open')) {
          menuItem.classList.remove('is-nested-open');
        }
      });

      return;
    }

    // Nested menu item
    if (menuItem.textContent.indexOf(nestedItemDetectText) >= 0) {
      menuItem.classList.add(nestedItemClass);
      menuItem.innerHTML = menuItem.innerHTML.replaceAll(nestedItemDetectText, "");

      nestedMenuMap.set(menuItem, currentNestMenu);
    }

  });

  if (nestedMenuMap.size > 0) {
    const navContainer = document.querySelector('nav');
    navContainer.classList.add("nested-menu-container");
  }

  nestedMenuMap.forEach((nestedMenu, nestedMenuItem) => {
    nestedMenu.append(nestedMenuItem);
  });

}
